import React from 'react';
import PageLayout from "../components/page-layout";

export default function Dashboard() {

    return (
        <PageLayout pageTitle="داشبورد">

        </PageLayout>
    );
}

